document.addEventListener("DOMContentLoaded", function() {
  // 1. Lấy tags của sản phẩm hiện hành từ biến global do Shopify Liquid gán
  // Đảm bảo bạn đã khai báo thẻ này trong file liquid trước khi import script nhé:
  // <script> window.argentProductTags = {{ product.tags | json }}; </script>
  if (!window.argentProductTags || !Array.isArray(window.argentProductTags)) return;

  // 2. Cấu hình bảng Size Map (Map chữ cái sang chữ hoa tương ứng)
  // Nếu tương lai có thêm Medium (m), Extra Large (xl) thì chỉ việc thêm vào Object này
  const SIZE_MAP = {
    's': 'SMALL',
    'l': 'LARGE'
  };

  // Hàm Parser: Dịch chuỗi "1l_2s" thành chuỗi Combo chuẩn YMQ "1 x LARGE + 2 x SMALL"
  function parseComboText(comboTagStr) {
    const parts = comboTagStr.split('_');
    const comboTextArray = parts.map(p => {
      // RegExp tách số đầu và các chữ cái đằng sau. Vd "1s" -> qty: 1, Ltr: s
      const match = p.match(/^(\d+)([a-z]+)$/i);
      if (match) {
         let qty = match[1];
         let sizeLtr = match[2].toLowerCase();
         return `${qty} x ${SIZE_MAP[sizeLtr] || sizeLtr.toUpperCase()}`;
      }
      return p; // Trả lại gốc nếu không đúng format
    });
    return comboTextArray.join(' + ');
  }

  // 3. Khởi tạo kho chứa (Repository) quy tắc, sẽ nạp từ tags vào đây
  const rules = {
    opts: [],               // Mảng các chuỗi Text Combo bị ẩn. VD: ['1 x LARGE + 2 x SMALL']
    globalStones: [],       // Mảng đá bị ẩn toàn cục. VD: ['ruby', 'emerald']
    sizeStones: {},         // Object các size bị ẩn đá. VD: { 'large': ['emerald'] }
    comboStones: {},        // Object combo bị ẩn đá. VD: { '2 x LARGE + 1 x SMALL': ['diamond'] }
    posStones: {}           // Object vị trí cố định bị ẩn đá. VD: { 'large_1': ['opal'] }
  };

  // 4. Lọc và Quét toàn bộ tags của sản phẩm
  window.argentProductTags.forEach(tag => {
    let t = tag.toLowerCase().trim();
    
    // Quy tắc 1 của bảng SOP: Ẩn cả 1 Option Combo lớn (no_opt_1l_2s)
    if (t.startsWith('no_opt_')) {
      rules.opts.push(parseComboText(t.replace('no_opt_', '')));
    }
    
    // Các quy tắc 2, 3, 4, 5 của bảng SOP: Liên quan đến loại trừ các viên Đá (cấm đá)
    else if (t.startsWith('no_stone_')) {
      let rest = t.replace('no_stone_', '');
      
      // Quy tắc 4: Ẩn đá khi đang chọn một Option Combo cụ thể (no_stone_ruby_in_1l_2s)
      if (rest.includes('_in_')) {
        let [stone, comboStr] = rest.split('_in_');
        let exactComboText = parseComboText(comboStr);
        if (!rules.comboStones[exactComboText]) rules.comboStones[exactComboText] = [];
        rules.comboStones[exactComboText].push(stone);
      } 
      else {
        let isMatched = false;
        
        // Checklist loop qua các Size hiện hành. Thêm 'medium' nếu tương lai có.
        ['large', 'small'].forEach(sz => {
          
          // Quy tắc 3: Ẩn cho cả nhánh Size này (no_stone_emerald_large)
          if (rest.endsWith('_' + sz)) { 
            let stone = rest.replace('_' + sz, '');
            if (!rules.sizeStones[sz]) rules.sizeStones[sz] = [];
            rules.sizeStones[sz].push(stone);
            isMatched = true;
          } 
          
          // Quy tắc 5: Ẩn ở chính xác Viên Đá Số mấy đó (no_stone_opal_large_1)
          else if (rest.match(new RegExp(`_${sz}_\\d+$`))) { 
            let parts = rest.split(`_${sz}_`);
            let stone = parts[0];
            let posIdx = parts[1];
            let targetKey = `${sz}_${posIdx}`; // Gộp thành key: large_1
            if (!rules.posStones[targetKey]) rules.posStones[targetKey] = [];
            rules.posStones[targetKey].push(stone);
            isMatched = true;
          }
        });

        // Quy tắc 2: Nếu vòng lặp trên không móc được mảng nào, nghĩa là nó là Ẩn Toàn Cục SP này (no_stone_ruby)
        if (!isMatched) {
           rules.globalStones.push(rest);
        }
      }
    }
  });

  // 5. Nếu không có bộ lọc đá hay bộ lọc option nào, kết thúc để tiết kiệm tài nguyên
  const isHasRules = rules.opts.length > 0 || rules.globalStones.length > 0 
                     || Object.keys(rules.sizeStones).length > 0 
                     || Object.keys(rules.comboStones).length > 0 
                     || Object.keys(rules.posStones).length > 0;
                     
  if(!isHasRules) return;

  // 6. Hook vào MutationObserver để can thiệp thẻ nội dung của YMQ
  const observer = new MutationObserver(() => {
    
    // TÁC VỤ A: Lọc các Option tại Dropdown chính (Stone Combination & Stone Size)
    if (rules.opts.length > 0) {
       document.querySelectorAll('.ymq-option-value').forEach(span => {
         let rawText = span.getAttribute('data-raw-text') || span.innerText.trim();
         if (rules.opts.includes(rawText)) {
            let li = span.closest('li.ymq-multiple-li');
            if (li && li.style.getPropertyValue('display') !== 'none') {
               li.style.setProperty('display', 'none', 'important');
            }
         }
       });
    }

    // Đọc trạng thái Option Combo hiện tại khách hàng đang click 
    // (Bắt thẻ có class active đang nằm trong thẻ select "properties[Stone Combination & Stone Size]")
    const currentComboActiveLi = document.querySelector('[data-name="properties[Stone Combination & Stone Size]"] li.ymq-multiple-li.active .ymq-option-value');
    const currentComboText = currentComboActiveLi ? (currentComboActiveLi.getAttribute('data-raw-text') || currentComboActiveLi.innerText.trim()) : '';


    // TÁC VỤ B: Lọc các Option màu Đá từng hột
    document.querySelectorAll('.ymq-options-box').forEach(box => {
      let labelSpan = box.querySelector('.ymq_lable');
      if (!labelSpan) return;
      let labelName = labelSpan.innerText.trim().toLowerCase(); // VD: "stone large (1)"
      
      // Chúng ta chỉ scan các box thả xuống chọn từng viên đá
      if (labelName.startsWith('stone ')) {
        // Tách lọc Size (vd: large) và STT Vị trí (vd: 1)
        let matchInfo = labelName.match(/stone (\w+)\s*\((\d+)\)/);
        if (!matchInfo) return;

        let boxSize = matchInfo[1]; // vd: 'large'
        let boxIdx = matchInfo[2];  // vd: '1'

        box.querySelectorAll('li.ymq-multiple-li').forEach(li => {
          let stoneSpan = li.querySelector('div[aria-label]');
          if(!stoneSpan) return;
          
          let stoneName = stoneSpan.getAttribute('aria-label').toLowerCase().trim(); // vd: "pink sapphire"
          let parsedStoneName = stoneName.replace(/\s+/g, '_'); // vd: "pink_sapphire"

          let shouldHide = false;

          // Bộ lọc 2: Ẩn Global viên đá này
          if (rules.globalStones.includes(parsedStoneName)) shouldHide = true;
          
          // Bộ lọc 3: Ẩn riêng cho size đá này
          if (rules.sizeStones[boxSize] && rules.sizeStones[boxSize].includes(parsedStoneName)) shouldHide = true;

          // Bộ lọc 4: Ẩn do rào cản của Combo "Stone Combination" khách đang bấm hiện tại
          if (rules.comboStones[currentComboText] && rules.comboStones[currentComboText].includes(parsedStoneName)) shouldHide = true;

          // Bộ lọc 5: Cấm riêng cái ngón đá STT vị trí này
          let posKey = `${boxSize}_${boxIdx}`; // vd: large_1
          if (rules.posStones[posKey] && rules.posStones[posKey].includes(parsedStoneName)) shouldHide = true;

          // Kích hoạt Ẩn/Hiện UI trên màn hình
          if (shouldHide) {
             if (li.style.getPropertyValue('display') !== 'none') {
                 li.style.setProperty('display', 'none', 'important');
             }
          } else {
             if (li.style.getPropertyValue('display') === 'none') {
                 li.style.removeProperty('display');
             } // Undo, thả tự do cho Viên đá hiên lại nếu hết bị cấm
          }
        });
      }
    });
  });

  // Chạy DOM Observer liên tục lắng nghe thay đổi
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

});
